import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function HotRecommend() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
              热门推荐
            </h2>
            <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-600 text-xs font-medium">HOT</span>
          </div>
          <Link to="/category/movie" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1">
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotMovies.slice(0, 6).map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`${movie.title} - 糖心影视高清在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={index > 2 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium">
                  {movie.rating}
                </div>
                <div className="absolute top-3 right-3 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs">
                  {movie.category}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                  <span className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium flex items-center gap-1.5">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-play-fill text-sm"></i>
                    </div>
                    立即播放
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {movie.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed flex-1">
                  {movie.description}
                </p>
                <div className="flex flex-wrap items-center gap-2 mt-3">
                  {movie.tags.slice(0, 3).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-400">{movie.year}年</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line text-xs"></i>
                    </div>
                    {(movie.views / 10000).toFixed(0)}万次播放
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}